
import Dashboard from "./tabs/Dashboard";
import Assets from "./tabs/Assets";
import Rules from "./tabs/Rules";
import Findings from "./tabs/Findings";
import SensitiveData from "./tabs/Sensitive_data";
import Risk from "./tabs/Risk";
import Compliance from "./tabs/Compliance";
import CompliancePlatformAdmin from "./tabs/CompliancePlatformAdmin";
import Reports from "./tabs/Reports";
import Settings from "./tabs/Settings";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { TabNavigation } from "../ui";
import CRMModuleHeader from "../ui/CRMModuleHeader";
import {
  Database,
  Shield,
  FileText,
  Lock,
  AlertTriangle,
  BadgeCheck,
  Settings as SettingsIcon
} from "lucide-react";

const AI_DSPM = () => {
   const { isPlatformAdmin } = useAuth();
   const [searchParams] = useSearchParams();
   const [activeTab, setActiveTab] = useState(searchParams.get("tab") || "dashboard");

   // Lets a notification deep-link into a specific tab via ?tab=findings,
   // same convention CSPM already uses.
   useEffect(() => {
     const tab = searchParams.get("tab");
     if (tab) setActiveTab(tab);
   }, [searchParams]);
const tabs = [
  { id: "dashboard", label: "Dashboard", icon: Database },
  { id: "assets", label: "Assets", icon: Shield },
  { id: "rules", label: "Rules", icon: FileText },
  { id: "findings", label: "Findings", icon: AlertTriangle },
  { id: "sensitive", label: "Classification", icon: Lock },
  // { id: "risks", label: "Risks", icon: AlertTriangle },
  { id: "compliance", label: "Compliance", icon: BadgeCheck },
  // { id: "reports", label: "Reports", icon: FileText },
  // { id: "settings", label: "Settings", icon: SettingsIcon },
];
  return (
    <>
      <div className="p-3 sm:p-4 md:p-6 max-w-full mx-auto dark:bg-[#0f172a] min-h-screen">
        <CRMModuleHeader
          icon={Database}
          title="AI DSPM Dashboard"
          description="AI Powered Data Security Posture Management"
        />
        <TabNavigation
          tabs={tabs.map((tab) => ({ id: tab.id, name: tab.label, icon: tab.icon }))}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
        {activeTab === "dashboard" && <Dashboard activeTab={activeTab} />}
        {activeTab === "assets" && <Assets activeTab={activeTab} />}
        {activeTab === "rules" && <Rules activeTab={activeTab} />}
        {activeTab === "findings" && <Findings activeTab={activeTab} />}
        {activeTab === "sensitive" && <SensitiveData activeTab={activeTab} />}
        {/* {activeTab === "risks" && <Risk activeTab={activeTab} />} */}
        {activeTab === "compliance" && (
          isPlatformAdmin
            ? <CompliancePlatformAdmin activeTab={activeTab} />
            : <Compliance activeTab={activeTab} />
        )}
        {/* {activeTab === "reports" && <Reports activeTab={activeTab} />} */}
        {/* {activeTab === "settings" && <Settings activeTab={activeTab} />} */}
      </div>
    </>
  );
};

export default AI_DSPM;